module.exports = __webpack_public_path__ + "static/media/kitchen-light.8c8315e4.jpg";